import type { ID } from '@octopus-do/octopus-project-core'

import type { ProjectParents, Workspace } from '../types'

export const findProjectParents = (
  id: ID,
  dashboard: Workspace[]
): ProjectParents | null => {
  for (const workspace of dashboard) {
    for (const folder of workspace.folders) {
      const project = folder.projects.find((p) => p.id === id)
      if (project) {
        return { workspace, folder, project }
      }
    }
  }
  return null
}
